import script from "./UserLocationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserLocationForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__